import React, { useMemo, useState } from "react";
import FilterIcon from "../assets/images/contact_page_icons/filtericon.svg";
import ExportIcon from "../assets/images/contact_page_icons/export.svg";
import AddIcon from "../assets/images/global_icons/basil_add-solid.svg";
import { CONTACT, EXPORT_CONTACT, OCR_UPLOAD, OCR_ANALYZE, CONTACT_MANUAL, OCR_SAVE } from "../utils/constants/apiUrl";
// import classes from "../assets/styles/Contact.module.css";
import GridView from "../components/PageComponents/Contact/GridView";
import ListView from "../components/PageComponents/Contact/ListView";
import { BsGrid } from "react-icons/bs";
import { TbLayoutList } from "react-icons/tb";
import { FiCreditCard } from "react-icons/fi";
import { useEffect } from "react";
import { get, deleteRecord, post } from "../server";
import { loggedInUser, teamIDCheck } from "../utils/store";
import { useAtom } from "jotai";
import Loader from "../components/Loader";
import ConfirmationModal from "../components/Modals/ConfirmationModal";
import showToast from "../helpers/showToast";
import FormInput from "../components/Forms/FormInput";
import Pagination from "react-bootstrap/Pagination";
import searchIcon from "../assets/images/contact_page_icons/searchicon.svg";
import { useNavigate } from "react-router-dom";
import useFunctionsCount from "../hooks/useFunctionsCount";
import functionTypes from "../utils/constants/functionTypes";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { saveAs } from "file-saver";
import { Button, InputGroup, Modal, Spinner, Form } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { FaIdCard, FaArrowRight, FaCheckCircle } from "react-icons/fa";
const Contact = () => {
  const [loggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [gridView, setGridView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadingCard, setUploadingCard] = useState(false);

  const [showResolutionModal, setShowResolutionModal] = useState(false);
  const [ocrResultData, setOcrResultData] = useState(null);
  const [ocrImages, setOcrImages] = useState({ logo: null, profile_image: null });
  const [selectedDuplicateAction, setSelectedDuplicateAction] = useState("new");
  const [selectedDuplicateId, setSelectedDuplicateId] = useState(null);
  const [resolvedFields, setResolvedFields] = useState([]);
  const [showAllSuggestions, setShowAllSuggestions] = useState(false);
  const [showSuggestionsSuccess, setShowSuggestionsSuccess] = useState(false);
  const [dismissOcrSummary, setDismissOcrSummary] = useState(false);
  const [editOriginalFields, setEditOriginalFields] = useState({
    first_name: "", last_name: "", email: "", company: "", company_position: "", website_url: "", phones: "", address: ""
  });
  const [editAiFields, setEditAiFields] = useState({
    first_name: "", last_name: "", email: "", company: "", company_position: "", website_url: "", phones: "", address: ""
  });

  useEffect(() => {
    if (ocrResultData) {
      setResolvedFields([]);
      setShowAllSuggestions(false);
      setShowSuggestionsSuccess(false);
      setDismissOcrSummary(false);
      if (ocrResultData.ocr_data) {
        setEditOriginalFields({
          first_name: ocrResultData.ocr_data.first_name || "",
          last_name: ocrResultData.ocr_data.last_name || "",
          email: ocrResultData.ocr_data.email || "",
          company: ocrResultData.ocr_data.company || "",
          company_position: ocrResultData.ocr_data.company_position || "",
          website_url: ocrResultData.ocr_data.website_url || ocrResultData.ocr_data.website || "",
          phones: Array.isArray(ocrResultData.ocr_data.phones) ? ocrResultData.ocr_data.phones.join(", ") : (ocrResultData.ocr_data.phones || ""),
          address: ocrResultData.ocr_data.address || "",
        });
      }

      if (ocrResultData.ai_suggestions?.corrected_data) {
        setEditAiFields({
          first_name: ocrResultData.ai_suggestions.corrected_data.first_name || "",
          last_name: ocrResultData.ai_suggestions.corrected_data.last_name || "",
          email: ocrResultData.ai_suggestions.corrected_data.email || "",
          company: ocrResultData.ai_suggestions.corrected_data.company || "",
          company_position: ocrResultData.ai_suggestions.corrected_data.company_position || "",
          website_url: ocrResultData.ai_suggestions.corrected_data.website_url || ocrResultData.ai_suggestions.corrected_data.website || "",
          phones: Array.isArray(ocrResultData.ai_suggestions.corrected_data.phones) ? ocrResultData.ai_suggestions.corrected_data.phones.join(", ") : (ocrResultData.ai_suggestions.corrected_data.phones || ""),
          address: ocrResultData.ai_suggestions.corrected_data.address || "",
        });
      }
    }
  }, [ocrResultData]);

  const handleEditOriginalChange = (e) => {
    const { name, value } = e.target;
    setEditOriginalFields(prev => ({ ...prev, [name]: value }));
  };

  const handleEditAiChange = (e) => {
    const { name, value } = e.target;
    setEditAiFields(prev => ({ ...prev, [name]: value }));
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropRejected: (fileRejections) => {
      const errorMsg = fileRejections[0]?.errors[0]?.message || "Invalid file.";
      showToast(false, `Upload failed: ${errorMsg}`);
    },
    onDrop: async (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (!file) return;

      if (file.size > 10 * 1024 * 1024) {
        showToast(false, "Image size exceeds 10MB limit.");
        return;
      }

      const formData = new FormData();
      formData.append("image", file);
      formData.append("file", file);
      if (userTeamId) {
        formData.append("team_id", userTeamId);
      }

      setUploadingCard(true);
      try {
        const response = await fetch(OCR_UPLOAD, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${loggedUser.token}`,
          },
          body: formData,
        });

        const resData = await response.json();

        if (response.ok && resData.success !== false) {
          const extractedData = resData.data || resData;

          // Store logo and profile_photo from Node OCR response
          setOcrImages({
            logo: extractedData.logo?.logoImage || null,
            profile_image: extractedData.profile_photo?.profileImage || null,
          });

          const analyzePayload = {
            first_name: extractedData.first_name || "",
            last_name: extractedData.last_name || "",
            email: extractedData.email || "",
            company: extractedData.company || "",
            company_position: extractedData.company_position || "",
            website: extractedData.website || "",
            address: extractedData.address || "",
            phones: extractedData.phones || [],
            team_id: userTeamId || null,
          };

          const analyzeResponse = await fetch(OCR_ANALYZE, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${loggedUser.token}`,
            },
            body: JSON.stringify(analyzePayload),
          });

          const analyzeDataRaw = await analyzeResponse.json();

          if (analyzeResponse.ok && analyzeDataRaw.success !== false) {
            const analyzeData = analyzeDataRaw.data || analyzeDataRaw;
            setOcrResultData(analyzeData);

            if (analyzeData.has_duplicates && analyzeData.duplicates?.length > 0) {
              setSelectedDuplicateAction("merge");
              const firstDup = analyzeData.duplicates[0];
              setSelectedDuplicateId(firstDup.existing_contact_id || firstDup.contact_id || firstDup.id || null);
            } else {
              setSelectedDuplicateAction("new");
            }

            setShowUploadModal(false);
            setShowResolutionModal(true);
          } else {
            showToast(false, "Data extraction succeeded, but analysis failed. Review raw data.");
            setOcrResultData({ ocr_data: extractedData, has_duplicates: false });
            setSelectedDuplicateAction("new");
            setShowUploadModal(false);
            setShowResolutionModal(true);
          }
        } else {
          const errorMsg = resData.message || "Failed to process image.";
          const detailedErrors = resData.errors ? Object.values(resData.errors).flat().join(", ") : "";
          showToast(false, detailedErrors ? `${errorMsg}: ${detailedErrors}` : errorMsg);
        }
      } catch (error) {
        console.error("OCR Request failed:", error);
        showToast(false, "Network error while uploading image.");
      } finally {
        setUploadingCard(false);
      }
    },
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
      "image/webp": [".webp"]
    },
    multiple: false,
  });
  const { compareLimits, updateCount } = useFunctionsCount();
  const navigate = useNavigate();
  const [pageNo, setPageNo] = useState(1);
  const [perPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [filter, setFilter] = useState("");

  const [search, setSearch] = useState("");
  const [textSearch, setTextSearch] = useState("");
  const [activeTab, setActiveTab] = useState("card");

  const handleTabChange = (selectedTab) => {
    setActiveTab(selectedTab);
    loadContact(selectedTab);
  };

  const handleNavigation = () => {
    const res = compareLimits(functionTypes.CONNECTION);
    if (res)
      return showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
    navigate("/contacts/createManual");
  };

  const handleExportAllCollection = async () => {
    setLoading(true);
    let payload = {
      tab_type: activeTab,
      team_id: userTeamId,
    };
    let { status, message, data } = await post(
      // id ? EXPORT_CONTACT + queryString : EXPORT_CONTACT,
      EXPORT_CONTACT,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      const filePath = data.path;
      saveAs(filePath, "leads.xlsx");
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const handleExportCollection = async (id) => {
    setLoading(true);
    // const queryString = `?tab_type=${activeTab}&team_id=${userTeamId}`;
    let payload = {
      id: id,
      tab_type: activeTab,
      team_id: userTeamId,
    };

    if (id !== 0) {
      payload.id = id;
    }

    let { status, message, data } = await post(
      // id ? EXPORT_CONTACT + queryString : EXPORT_CONTACT,
      EXPORT_CONTACT,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      const filePath = data.path;
      saveAs(filePath, "leads.xlsx");
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const handleOcrSave = async () => {
    if (!ocrResultData) return;
    setLoading(true);

    const activeFields = editAiFields;

    if (selectedDuplicateAction === "merge" || selectedDuplicateAction === "keep_both") {
      if (!selectedDuplicateId) {
        showToast(false, "Please select an existing contact to target.");
        setLoading(false);
        return;
      }
    }

    let savePayload = {};

    const cityVal = activeFields.city || "";
    const stateVal = activeFields.state || "";
    const countryVal = activeFields.country || "";

    if (selectedDuplicateAction === "new" || selectedDuplicateAction === "keep_both") {
      savePayload = {
        action: selectedDuplicateAction,
        first_name: activeFields.first_name || "Unknown",
        last_name: activeFields.last_name || "",
        email: activeFields.email || "",
        company: activeFields.company || "",
        company_position: activeFields.company_position || "",
        website_url: activeFields.website_url || "",
        address: activeFields.address || "",
        city: cityVal,
        state: stateVal,
        country: countryVal,
        card_type: "business",
        contact_type: "lead",
        logo: ocrImages.logo || "",
        profile_image: ocrImages.profile_image || "",
        contact_card_phone: activeFields.phones ? activeFields.phones.split(",").map(p => ({ phone_number: p.trim(), phone_type: "mobile" })) : [],
        contact_card_social_media: []
      };

      if (selectedDuplicateAction === "keep_both") {
        savePayload.existing_contact_id = selectedDuplicateId;
      }
    } else if (selectedDuplicateAction === "merge") {
      savePayload = {
        action: "merge",
        first_name: activeFields.first_name || "Unknown",
        existing_contact_id: selectedDuplicateId,
        merge_fields: {
          first_name: activeFields.first_name || "Unknown",
          last_name: activeFields.last_name || "",
          email: activeFields.email || "",
          company: activeFields.company || "",
          company_position: activeFields.company_position || "",
          website_url: activeFields.website_url || "",
          address: activeFields.address || "",
          city: cityVal,
          state: stateVal,
          country: countryVal,
          logo: ocrImages.logo || "",
          profile_image: ocrImages.profile_image || "",
        },
        phone_action: {
          action: "add",
          phones: activeFields.phones ? activeFields.phones.split(",").map(p => ({ phone_number: p.trim(), phone_type: "mobile" })) : []
        },
        social_action: {
          action: "keep",
          entries: []
        }
      };
    }


    setLoading(true);

    try {
      const targetUrl = ocrResultData.has_duplicates ? OCR_SAVE : CONTACT_MANUAL;
      if (targetUrl === CONTACT_MANUAL && userTeamId) {
        savePayload.team_id = userTeamId;
      }
      let { status, message, data } = await post(
        targetUrl,
        savePayload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        showToast(true, "Contact saved successfully!");
        setShowResolutionModal(false);
        loadContact(activeTab);
      } else {
        showToast(false, message || "Failed to save contact.");
      }
    } catch (error) {
      console.error("OCR Save Error:", error);
      showToast(false, "Network error saving contact.");
    } finally {
      setLoading(false);
    }
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleDelete = (id) => {
    setDeleteId(id);
    handleShowModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseModal(true);
    setLoading(true);
    let { status, message } = await deleteRecord(
      `${CONTACT}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    showToast(status, message);

    if (status) {
      // contacts.filter((contact) => contact.contact_id !== deleteId);
      await loadContact();
      updateCount(functionTypes.CONNECTION, functionTypes.DELETE);
      setLoading(false);
    }
    setLoading(false);
  };

  const handleGridView = () => {
    setGridView(true);
  };

  const handleListView = () => {
    setGridView(false);
  };

  const handlePageClick = (event) => {
    setPageNo(Number(event.target.innerText));
  };

  const contactURL = useMemo(() => {
    let queryParams = "";
    if (userTeamId) {
      queryParams = `?team_id=${userTeamId}`;
    }

    let url = new URL(`${CONTACT}${queryParams}`);
    url.searchParams.append("tab_type", activeTab);
    url.searchParams.append("pagination", true);
    url.searchParams.append("page", pageNo);
    url.searchParams.append("per_page", perPage);
    url.searchParams.append("filter", filter);
    url.searchParams.append("search", search);

    return url.toString();
  }, [activeTab, pageNo, search, filter]);

  const getContactUrl = (selectedTab) => {
    let queryParams = "";
    if (userTeamId) {
      queryParams = `?team_id=${userTeamId}`;
    }

    let url = new URL(`${CONTACT}${queryParams}`);
    url.searchParams.append("tab_type", selectedTab);
    url.searchParams.append("pagination", true);
    url.searchParams.append("page", pageNo);
    url.searchParams.append("per_page", perPage);
    url.searchParams.append("filter", filter);
    url.searchParams.append("search", search);

    return url.toString();
  };

  const loadContact = async (selectedTab) => {
    setLoading(true);

    let { status, message, data } = await get(
      getContactUrl(selectedTab),
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    setTotalRecords(data?.pagination?.total);
    setTotalPages(Math.ceil(data?.pagination?.total / perPage));

    if (status) {
      if (data.length == 0) {
        setContacts([]);
      } else if (data.data.length > 0) {
        let contactCards = [];
        data.data.forEach((contact) => {
          contact.contactCard.card_social_media =
            contact.contactCard.contact_card_social_media;
          contact.contactCard.uuid = contact.uuid;
          contact.contactCard.is_manual = contact.is_manual;
          delete contact.contactCard.contact_card_social_media;
          contactCards.push(contact.contactCard);
        });
        setContacts(contactCards);
      } else {
        setContacts([]);
      }
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  // useEffect(() => {
  //   loadContact("card");
  // }, []);

  useEffect(() => {
    loadContact(activeTab);
  }, [search, filter, pageNo, activeTab]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearch(textSearch);
      setPageNo(1); // Optional: Reset to page 1 when search
    }, 500); // 500ms debounce delay

    return () => clearTimeout(delayDebounce);
  }, [textSearch]);

  const returnPages = () => {
    let items = [];

    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === pageNo}>
          {number}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <>
      {!loading ? (
        <div className="">
          <div className="mobileViewWrapper">
            <div className="heading">
              <h1>
                Connections <span>({totalRecords})</span>
              </h1>
            </div>
            {/* <p className={classes.title}> */}

            {/* </p> */}
            <div className="d-flex gap-2">
              {activeTab === "card" && (
                <Button variant="primary" onClick={handleNavigation}>
                  <img src={AddIcon} alt="plus" className="me-2" />
                  New Connection
                </Button>
              )}
              {activeTab === "card" && (
                <Button
                  variant="primary"
                  onClick={() => setShowUploadModal(true)}
                >
                  Upload Physical Card
                </Button>
              )}
            </div>
            <div className="iconsWrapper">
              <div className="dropdown">
                <button
                  className="customActionDropdown dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src={FilterIcon} alt="" width="16px" height="16px" />
                </button>
                <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-start ">
                  <li className="dropdown-item">
                    <span
                      onClick={() => setFilter("newest")}
                      style={{
                        color:
                          filter === "" || filter === "newest"
                            ? "var(--primary_button_color)"
                            : "var(--primary_text_color)",
                      }}
                    >
                      Newest to oldest
                    </span>
                  </li>
                  <li className="dropdown-item">
                    <span
                      onClick={() => setFilter("oldest")}
                      style={{
                        color:
                          filter === "oldest"
                            ? "var(--primary_button_color)"
                            : "var(--primary_text_color)",
                      }}
                    >
                      Oldest to newest
                    </span>
                  </li>
                  <li className="dropdown-item">
                    <span
                      style={{ color: "#E35252" }}
                      onClick={() => setFilter("")}
                    >
                      Clear
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mainVeiwsWrapper">
            <div className="veiwsWrapper">
              {/* <form
                className="search-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  setSearch(textSearch);
                }}
              >
                <InputGroup className="form-group">
                  <InputGroup.Text id="basic-addon1">
                    <img
                      src={searchIcon}
                      alt="search"
                      className="search-icon"
                    />
                  </InputGroup.Text>
                  <input
                    type="text"
                    className="search-input form-control input-group-form-control"
                    placeholder="Search..."
                    value={textSearch}
                    onChange={(e) => {
                      if (e.target.value.length === 0 && search.length !== 0) {
                        setSearch("");
                      }
                      setTextSearch(e.target.value);
                    }}
                  />
                </InputGroup>
              </form> */}

              <form className="search-form">
                <InputGroup className="form-group">
                  <InputGroup.Text id="basic-addon1">
                    <img
                      src={searchIcon}
                      alt="search"
                      className="search-icon"
                    />
                  </InputGroup.Text>
                  <input
                    type="text"
                    className="search-input form-control input-group-form-control"
                    placeholder="Search..."
                    value={textSearch}
                    onChange={(e) => setTextSearch(e.target.value)}
                  />
                </InputGroup>
              </form>

              <div className="d-flex gap-2">
                {(activeTab === "card" || activeTab === "lead") && (
                  <button
                    className="btn connections-btn d-flex align-items-center gap-2 ms-3"
                    onClick={handleExportAllCollection}
                  >
                    <img src={ExportIcon} alt="" width="16px" height="16px" />
                    Export Collection
                  </button>
                )}
                <div className="dropdown">
                  <button
                    className="btn connections-btn d-flex align-items-center gap-2"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={FilterIcon} alt="Filter" width="16" height="16" />
                    <span>Filter</span>
                  </button>
                  <ul className="dropdown-menu">
                    <li
                      className="dropdown-item"
                      onClick={() => setFilter("newest")}
                    >
                      <span
                        style={{
                          color:
                            filter === "" || filter === "newest"
                              ? "var(--primary_button_color)"
                              : "var(--primary_text_color)",
                        }}
                      >
                        Newest to oldest
                      </span>
                    </li>
                    <li
                      className="dropdown-item"
                      onClick={() => setFilter("oldest")}
                    >
                      <span
                        style={{
                          color:
                            filter === "oldest"
                              ? "var(--primary_button_color)"
                              : "var(--primary_text_color)",
                        }}
                      >
                        Oldest to newest
                      </span>
                    </li>
                    <li className="dropdown-item" onClick={() => setFilter("")}>
                      <span style={{ color: "#E35252" }}>Clear</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="listWrapper mt-4">
            <Tabs
              defaultActiveKey="card"
              activeKey={activeTab}
              className="customSubscriptionTabs"
              transition={false}
              onSelect={handleTabChange}
            >
              <Tab eventKey="card" title="Connections">
                {/* {gridView ? (
                  <GridView
                    contacts={contacts}
                    handleDelete={handleDelete}
                    handleExportCollection={handleExportCollection}
                  />
                ) : ( */}
                <ListView
                  contacts={contacts}
                  handleDelete={handleDelete}
                  handleExportCollection={handleExportCollection}
                />
                {/* )} */}

                <div className="paginationWrapper">
                  <Pagination onClick={handlePageClick}>
                    {returnPages()}
                  </Pagination>
                </div>
              </Tab>
              <Tab eventKey="lead" title="Lead">
                {/* {gridView ? (
                  <GridView
                    contacts={contacts}
                    handleDelete={handleDelete}
                    handleExportCollection={handleExportCollection}
                  />
                ) : ( */}
                <ListView
                  contacts={contacts}
                  handleDelete={handleDelete}
                  handleExportCollection={handleExportCollection}
                />
                {/* )} */}

                <div className="paginationWrapper">
                  <Pagination onClick={handlePageClick}>
                    {returnPages()}
                  </Pagination>
                </div>
              </Tab>
              <Tab eventKey="custom_url" title="Custom URL's">
                {/* {gridView ? (
                  <GridView contacts={contacts} handleDelete={handleDelete} />
                ) : ( */}
                <ListView contacts={contacts} handleDelete={handleDelete} />
                {/* )} */}

                <div className="paginationWrapper">
                  <Pagination onClick={handlePageClick}>
                    {returnPages()}
                  </Pagination>
                </div>
              </Tab>
              <Tab eventKey="file_upload" title="File Upload URL">
                {/* {gridView ? (
                  <GridView contacts={contacts} handleDelete={handleDelete} />
                ) : ( */}
                <ListView contacts={contacts} handleDelete={handleDelete} />
                {/* )} */}

                <div className="paginationWrapper">
                  <Pagination onClick={handlePageClick}>
                    {returnPages()}
                  </Pagination>
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      ) : (
        <Loader />
      )}

      {/* Resolution Modal for OCR */}
      <Modal
        show={showResolutionModal}
        onHide={() => setShowResolutionModal(false)}
        size="lg"
        centered
        backdrop="static"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Review Scanned Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {ocrResultData && (
            <div>
              {ocrResultData.ai_suggestions?.corrected_data && (
                <div className="mb-4 p-3 bg-light rounded border">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold text-success mb-0">AI Suggestions</h6>
                  </div>

                  <p className="text-muted small mb-3">The AI detected potential typos and suggested improvements. You can accept or ignore individual suggestions below.</p>

                  {(() => {
                    const suggestionList = [
                      { key: "first_name", label: "First Name", original: editOriginalFields.first_name, suggested: editAiFields.first_name },
                      { key: "last_name", label: "Last Name", original: editOriginalFields.last_name, suggested: editAiFields.last_name },
                      { key: "company", label: "Company", original: editOriginalFields.company, suggested: editAiFields.company },
                      { key: "company_position", label: "Position", original: editOriginalFields.company_position, suggested: editAiFields.company_position },
                      { key: "website_url", label: "Website", original: editOriginalFields.website_url, suggested: editAiFields.website_url },
                      { key: "address", label: "Address", original: editOriginalFields.address, suggested: editAiFields.address },
                      { key: "email", label: "Email", original: editOriginalFields.email, suggested: editAiFields.email, isFixed: true },
                      { key: "phones", label: "Phone", original: editOriginalFields.phones, suggested: editAiFields.phones, isFixed: true },
                    ].filter(s => (s.isFixed || (s.original || "").trim() !== (s.suggested || "").trim()) && !resolvedFields.includes(s.key));

                    const totalSuggestions = suggestionList.filter(s => !s.isFixed).length;

                    if (showSuggestionsSuccess) {
                      return (
                        <div className="p-4 text-center bg-white border rounded shadow-sm mb-3">
                          <FaCheckCircle className="text-success fs-1 mb-3" />
                          <h6 className="fw-bold text-dark mb-1">All suggestions processed!</h6>
                          <p className="text-muted small mb-0">The contact record has been updated. You can now save or continue editing.</p>
                        </div>
                      );
                    }

                    return (
                      <>
                        {!showAllSuggestions && totalSuggestions > 0 && !dismissOcrSummary && (
                          <div className="p-3 mb-3 border shadow-sm" style={{ background: "#E6F4F1", borderRadius: "12px", borderColor: "#B2DFD6", position: "relative" }}>
                            <button
                              className="btn-close position-absolute top-0 end-0 m-2"
                              style={{ fontSize: "0.7rem" }}
                              onClick={() => {
                                setDismissOcrSummary(true);
                              }}
                            ></button>
                            <h6 className="fw-bold text-success mb-2" style={{ fontSize: "1rem" }}>{totalSuggestions} smart improvements suggested</h6>
                            <p className="text-muted small mb-2">Identified corrections for names, companies, or websites extracted from the card.</p>
                            <button
                              className="btn btn-link p-0 text-dark fw-bold text-decoration-none small"
                              style={{ fontSize: "0.85rem" }}
                              onClick={() => setShowAllSuggestions(true)}
                            >
                              Review All
                            </button>
                          </div>
                        )}

                        {showAllSuggestions && (
                          <div className="d-flex flex-column gap-3 mb-3">
                            <div className="d-flex justify-content-end">
                              <button
                                className="btn btn-link p-0 text-muted small text-decoration-none"
                                style={{ fontSize: "0.85rem" }}
                                onClick={() => setShowAllSuggestions(false)}
                              >
                                Close
                              </button>
                            </div>
                            {suggestionList.map((s) => (
                              <div key={s.key} className="p-3 bg-white border rounded shadow-sm">
                                <h6 className="fw-bold mb-2" style={{ fontSize: "0.85rem", color: "#22A081", textTransform: "uppercase" }}>{s.label}</h6>
                                <div className="row align-items-center mb-2">
                                  <div className="col-5">
                                    <small className="text-muted d-block extra-small" style={{ fontSize: "0.65rem", fontWeight: "600", textTransform: "uppercase" }}>Scanned</small>
                                    <span className="text-dark" style={{ fontSize: "0.9rem", wordBreak: "break-all" }}>{s.original || <span className="text-muted fst-italic">Empty</span>}</span>
                                  </div>
                                  <div className="col-1 text-center text-muted px-0">
                                    <FaArrowRight className="fs-6" />
                                  </div>
                                  <div className="col-6">
                                    <small className="text-muted d-block extra-small" style={{ fontSize: "0.65rem", fontWeight: "600", textTransform: "uppercase" }}>Suggested</small>
                                    <span className={(s.original || "").trim() !== (s.suggested || "").trim() ? "fw-bold text-success" : "text-dark"} style={{ fontSize: "0.9rem", wordBreak: "break-all" }}>
                                      {s.suggested}
                                    </span>
                                  </div>
                                </div>

                                {!s.isFixed && (
                                  <div className="d-flex gap-3 border-top pt-2">
                                    <button
                                      className="btn btn-link btn-sm p-0 text-success fw-bold text-decoration-none"
                                      onClick={() => {
                                        setEditAiFields(prev => ({ ...prev, [s.key]: s.suggested }));
                                        setResolvedFields(prev => [...prev, s.key]);
                                      }}
                                    >
                                      Accept
                                    </button>
                                    <button
                                      className="btn btn-link btn-sm p-0 text-muted text-decoration-none"
                                      onClick={() => {
                                        setEditAiFields(prev => ({ ...prev, [s.key]: s.original }));
                                        setResolvedFields(prev => [...prev, s.key]);
                                      }}
                                    >
                                      Ignore
                                    </button>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}

                        {showAllSuggestions && suggestionList.length > 0 && (
                          <button
                            className="btn btn-success w-100 fw-bold py-2 shadow-sm mt-2"
                            onClick={() => {
                              setEditAiFields(prev => ({
                                ...prev,
                                first_name: ocrResultData.ai_suggestions.corrected_data.first_name || prev.first_name,
                                last_name: ocrResultData.ai_suggestions.corrected_data.last_name || prev.last_name,
                                company: ocrResultData.ai_suggestions.corrected_data.company || prev.company,
                                company_position: ocrResultData.ai_suggestions.corrected_data.company_position || prev.company_position,
                                website_url: ocrResultData.ai_suggestions.corrected_data.website_url || ocrResultData.ai_suggestions.corrected_data.website || prev.website_url,
                                address: ocrResultData.ai_suggestions.corrected_data.address || prev.address,
                              }));
                              setResolvedFields(prev => [...prev, "first_name", "last_name", "company", "company_position", "website_url", "address", "email", "phones"]);
                              setShowSuggestionsSuccess(true);
                            }}
                          >
                            Apply All Suggestions
                          </button>
                        )}
                      </>
                    );
                  })()}
                </div>
              )}

              {ocrResultData.has_duplicates && ocrResultData.duplicates && (
                <div className="mb-4">
                  <div className="p-3 border-start border-4 border-danger rounded bg-light mb-4 shadow-sm">
                    <h6 className="fw-bold text-danger mb-2">Duplicate Record Identified</h6>
                    <div className="text-muted small">
                      <p className="mb-2">An existing record was found matching the email address:&nbsp;
                        <span className="fw-bold text-dark">
                          {ocrResultData.ocr_data?.email || ocrResultData.ai_suggestions?.corrected_data?.email}
                        </span>
                      </p>
                      <p className="mb-0">To ensure data accuracy, please review the incoming details and merge them into the existing record below.</p>
                    </div>
                  </div>

                  {ocrResultData.duplicates.length > 0 && (
                    <div className="p-3 border rounded bg-light mb-4">
                      <p className="fw-bold small mb-3">Resolve Conflicts:</p>

                      {[
                        { key: "first_name", label: "First Name" },
                        { key: "last_name", label: "Last Name" },
                        { key: "company", label: "Company" },
                        { key: "company_position", label: "Position" },
                        { key: "website_url", label: "Website" },
                        { key: "address", label: "Address" },
                      ]
                        .filter((f) => (editOriginalFields[f.key] || "").toString().trim() !== (editAiFields[f.key] || "").toString().trim())
                        .map((field) => (
                          <div key={field.key} className="mb-4">
                            <label className="fw-bold small mb-0 d-block">{field.label}</label>
                            <small className="text-danger d-block mb-2" style={{ fontSize: "0.7rem", fontWeight: "600" }}>Conflict detected</small>

                            <div className="row gx-2 mb-2">
                              <div className="col-6">
                                <div className="p-2 border rounded bg-white h-100" style={{ fontSize: "0.85rem" }}>
                                  <div className="text-muted mb-1" style={{ fontSize: "0.65rem", fontWeight: "600", textTransform: "uppercase" }}>Existing</div>
                                  <div className="text-dark fw-medium">{editOriginalFields[field.key] || <span className="text-muted fst-italic">Empty</span>}</div>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="p-2 border rounded bg-white h-100" style={{ fontSize: "0.85rem" }}>
                                  <div className="text-muted mb-1" style={{ fontSize: "0.65rem", fontWeight: "600", textTransform: "uppercase" }}>New</div>
                                  <div className="text-dark fw-medium">{editAiFields[field.key] || <span className="text-muted fst-italic">Empty</span>}</div>
                                </div>
                              </div>
                            </div>

                            <Form.Control
                              type="text"
                              name={field.key}
                              value={editAiFields[field.key]}
                              onChange={handleEditAiChange}
                              className="bg-white"
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        ))}

                      {[
                        { key: "first_name", label: "First Name" },
                        { key: "last_name", label: "Last Name" },
                        { key: "company", label: "Company" },
                        { key: "company_position", label: "Position" },
                        { key: "website_url", label: "Website" },
                        { key: "address", label: "Address" },
                      ].filter((f) => (editOriginalFields[f.key] || "").toString().trim() !== (editAiFields[f.key] || "").toString().trim()).length === 0 && (
                          <p className="text-success small mb-0">No field-level conflicts detected between existing and new data. All fields match.</p>
                        )}
                    </div>
                  )}
                </div>
              )}

              {!ocrResultData.has_duplicates && (
                <div className="mb-2">
                  <p className="text-muted">No duplicates detected. Ready to save.</p>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowResolutionModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleOcrSave} disabled={loading}>
            Save Contact
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmationModal
        show={showModal}
        handleCloseModal={handleCloseModal}
        handleConfirmDelete={handleConfirmDelete}
        confirmTitle="contact"
      />

      <Modal show={showUploadModal} onHide={() => !uploadingCard && setShowUploadModal(false)} centered>
        <Modal.Header closeButton={!uploadingCard}>
          <Modal.Title>Upload Physical Card</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div
            {...getRootProps()}
            className={`w-100 p-4 text-center cursor-pointer ${isDragActive ? 'bg-light' : ''}`}
            style={{ minHeight: '400px', display: 'flex', flexDirection: 'column', cursor: 'pointer' }}
          >
            <input {...getInputProps()} />
            <div
              className={`flex-grow-1 border rounded d-flex flex-column justify-content-center ${isDragActive ? 'border-primary bg-white' : 'border-dashed'}`}
              style={{ borderStyle: 'dashed', transition: 'all 0.2s', borderColor: isDragActive ? '#0d6efd' : '#ccc', pointerEvents: 'none' }}
            >
              {uploadingCard ? (
                <div className="py-4">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-3 text-muted">Uploading and extracting contact info...</p>
                </div>
              ) : (
                <div className="py-4">
                  <p className="mb-2 icon-primary"><FaIdCard size={40} /></p>
                  <p className="mb-1 fw-bold">Drag & drop a photo of the card here</p>
                  <p className="text-muted small">or click to select a file</p>
                  <p className="text-muted mt-3 mb-0" style={{ fontSize: '12px' }}>Supported formats: JPEG, JPG, PNG, WEBP (Max 10MB)</p>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Contact;
